import { ref } from 'vue';

export const useDataReady = () => {
  const isDataReady = ref<boolean>(false);

  const setDataIsReady = (): void => {
    isDataReady.value = true;
  };

  return {
    isDataReady,
    setDataIsReady,
  };
};
